<div
  id="current-zoom"
  *ngLet="currentZoom$ | async"
  class="clickable"
  ngbTooltip="Current map zoom level"
  placement="bottom"
  openDelay="500"
></div>
